import * as React from 'react';
import { RequestAppointmentPage } from 'src/Components/appt/components/RequestAppointmentPage';
import { ClientPage } from 'src/Components/Pages/ClientPage';

export interface IRequestAppointmentPageProps {}

const Page: React.FunctionComponent<IRequestAppointmentPageProps> = props => {
  return (
    <ClientPage>
      <RequestAppointmentPage />
    </ClientPage>
  );
};
export default Page;
